export function addConfig(color, useBot, botName) {
  return {
    type: '@config/ADD_CONFIG',
    payload: {
      color,
      useBot,
      botName
    }
  };
}